/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RedzoneTeamSplitsDisplayQueryVariables = {|
  teamIds?: ?$ReadOnlyArray<?string>,
  seasonID?: ?string,
|};
export type RedzoneTeamSplitsDisplayQueryResponse = {|
  +nflRedzoneTeamSplits: ?$ReadOnlyArray<?{|
    +id: string,
    +season: {|
      +year: number
    |},
    +team: {|
      +abbreviation: string
    |},
    +passes: number,
    +rushes: number,
    +totalPlays: ?number,
  |}>
|};
export type RedzoneTeamSplitsDisplayQuery = {|
  variables: RedzoneTeamSplitsDisplayQueryVariables,
  response: RedzoneTeamSplitsDisplayQueryResponse,
|};
*/


/*
query RedzoneTeamSplitsDisplayQuery(
  $teamIds: [ID]
  $seasonID: ID
) {
  nflRedzoneTeamSplits(teamIds: $teamIds, seasonId: $seasonID) {
    id
    season {
      year
      id
    }
    team {
      abbreviation
      id
    }
    passes
    rushes
    totalPlays
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seasonID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v2 = [
  {
    "kind": "Variable",
    "name": "seasonId",
    "variableName": "seasonID"
  },
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviation",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passes",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rushes",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalPlays",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RedzoneTeamSplitsDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NFLRedzoneTeamSplitsType",
        "kind": "LinkedField",
        "name": "nflRedzoneTeamSplits",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatSeasonType",
            "kind": "LinkedField",
            "name": "season",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RedzoneTeamSplitsDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NFLRedzoneTeamSplitsType",
        "kind": "LinkedField",
        "name": "nflRedzoneTeamSplits",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatSeasonType",
            "kind": "LinkedField",
            "name": "season",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e41d052e673d131e29c72ba0fcba74d",
    "id": null,
    "metadata": {},
    "name": "RedzoneTeamSplitsDisplayQuery",
    "operationKind": "query",
    "text": "query RedzoneTeamSplitsDisplayQuery(\n  $teamIds: [ID]\n  $seasonID: ID\n) {\n  nflRedzoneTeamSplits(teamIds: $teamIds, seasonId: $seasonID) {\n    id\n    season {\n      year\n      id\n    }\n    team {\n      abbreviation\n      id\n    }\n    passes\n    rushes\n    totalPlays\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a2c7b748d8e8ba9eec5d3ab034a9cb71';

module.exports = node;
